// Lib
import React from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Components
import LinkButton from '../../buttons/LinkButton';

// Types
import CanvasSizeError from '../../../canvas/CanvasSizeError';

interface Props {
    error: CanvasSizeError;
}

const CanvasSizeErrorContent = (props: Props) => {
    const { error } = props;

    const dispatch = useDispatch();

    const heading = error?.friendlyMessage ? error?.friendlyMessage : "The canvas can't grow this far";

    return (
        <>
            <h2>{heading}</h2>
            <div>
                {error?.tip ? <p>{error.tip}</p> : null}
                <div className="section">
                    <p>
                        Need help?{' '}
                        <LinkButton onClick={() => dispatch(intercomShowMessages())}>Contact support</LinkButton>
                    </p>
                </div>
            </div>
        </>
    );
};

export default CanvasSizeErrorContent;
